import axios from 'axios';
import { dropDown } from './interfaces'

const apiURL = process.env.REACT_APP_API_URL;

export const getInvoiceTemplateData = async (): Promise<dropDown[]> => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios.get(`https://${apiURL}/InvoiceTemplate/ForDropdown`, {
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   });

   const data = response.data;
   console.log(data)

   const invoiceTypeDropdownData: dropDown[] = (data as dropDown[]).map((item: any) => ({
      text: item.text,
      value: Number(item.value)
   }));

   return invoiceTypeDropdownData;
};

/**
 * Improves invoice item description using AI via backend API
 * @param invoiceTemplateId The invoice template ID
 * @param jobId The job ID
 * @param description The description text to improve
 * @returns Promise<string> The improved description text
 */
export const improveDescriptionWithAI = async (
   invoiceTemplateId: number, 
   jobId: number, 
   description: string
): Promise<string> => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   if (!description || description.trim() === '') {
      throw new Error('Description cannot be empty');
   }

   try {
      const response = await axios.get(
         `https://${apiURL}/InvoiceTemplate/${invoiceTemplateId}/job/${jobId}/useai`,
         {
            params: { description },
            headers: {
               'Content-Type': 'application/json',
               'Authorization': 'Bearer ' + token,
            }
         }
      );

      const improvedText = response.data;
      
      if (!improvedText || improvedText.trim() === '') {
         throw new Error('No response from AI service');
      }

      return improvedText;
   } catch (error: any) {
      if (error.response?.status === 401) {
         throw new Error('Unauthorized. Please log in again.');
      } else if (error.response?.status === 404) {
         throw new Error('Invoice template or job not found');
      } else if (error.response?.data?.message) {
         throw new Error(error.response.data.message);
      } else if (error.message) {
         throw error;
      } else {
         throw new Error('Failed to improve description with AI. Please try again.');
      }
   }
};